import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '55604014-8dd2845cb4f0c2c876bab87c6';

export function getImagesByQuery(query) {
  return axios
    .get(BASE_URL, {
      params: {
        key: API_KEY,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
      },
    })
    .then(response => response.data);
}
